import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from 'components';
import styles from './DocumentErrorDialog.module.scss';

type DocumentErrorDialogProps = {
    onClose: () => void;
    documentIdentifier?: string;
};

const DocumentErrorDialog = ({ onClose, documentIdentifier }: DocumentErrorDialogProps) => (
    <Dialog
        className={styles.dialog}
        autoFocus={true}
        onClose={onClose}
    >
        <div className={styles.content}>
            <div className={styles.title}>
                Error
            </div>
            <div className={styles.message}>
                Document download failed {documentIdentifier && `for file '${documentIdentifier}'`}. Please contact Website Support.
            </div>
        </div>
        <DialogActionsBar>
            <div className={styles.button}>
                <Button onClick={onClose}>
                    Close
                </Button>
            </div>
        </DialogActionsBar>
    </Dialog>
);

export default DocumentErrorDialog;
